import cipher34Hint1 from '../../../../assets/images/games/zdar-escape-game/ciphers/34/hint1.webp';
import track34 from '../../../../assets/audio/tracks/track34.mp3';

const hints = [
    {
        image: cipher34Hint1,
    },
    {
        text: 'Soška je na budově knihovny.',
    },
];
export const step34library = {
    id: 32,
    title: '15. stanoviště',
    taskText: `
        <p>
            Tak ten o tom taky slyšel a prý ví, kam jít dál. Kousek odtud dolů máme jít hledat svatou v domě a ta prý slyšela víc. 
        </p>
        <p>    
            On jenom ví, že prý určitě použijeme všechno to, co si píšeme, kromě těch pitomých ptáků pro lva. I když asi ta orlice by mohla ještě pomoci. Snad, už když jsme ji tak luštili. 
        </p>
    `,
    cipher: {
        title: 'Úkol',
        text: 'Pokud jste svatou našli, klikněte na zelené tlačítko níže.',
    },
    continueButtonText: 'Jsme na místě',
    catImage: 1,
    audio: track34,
    snowAudio: track34,
    hints: hints,
    snowHints: hints,
};
